// extracted by mini-css-extract-plugin
export default {"wrapper":"pPLa8bzp","labelText":"cVAICb4v","root":"WmJiwRb2","variatnCountContainer":"nOYVmedW","variatnCountItem":"VyJCjitn","currentCount":"dfMSFlnP","currentCountItem":"fivk7pr8"};